<template>
  <div>
    <div class="top_text"><v-icon>beenhere</v-icon>상품별 리포트</div>
    <div class="topTableWrap">
      <component :is="currentView"
        :campaignType="campaignType"
        :contractData="viewData"
        :parseDataType="parseDataType"
        :contractTotal="contractTotal"></component>
    </div>
  </div>
</template>

<script>
  import { parseDataType, getContractTotal, currentIPView } from '@/assets/func'

  import ContractBaseTable from './ContractBaseTable'
  import ContractInterPlay from './ContractInterPlay'
  import ContractInterPlayCV from './ContractInterPlayCV'
  import ContractInterPlayCPCV from './ContractInterPlayCPCV'

  export default {
    name: 'contract_imp',
    props: {
      campaignType: String,
      isInterPlay: Boolean,
      viewData: Array
    },
    components: {
      ContractBaseTable,
      ContractInterPlay,
      ContractInterPlayCV,
      ContractInterPlayCPCV
    },
    data () {
      return {
        initProgress: 0,
        down: 'keyboard_arrow_down',
        up: 'keyboard_arrow_up'
      }
    },
    methods: {
      parseDataType (data) {
        return parseDataType(data)
      }
    },
    computed: {
      contractTotal () {
        return getContractTotal(this.viewData, this.campaignType, this.isInterPlay)
      },
      currentView () { // 일반 상품, 인터플레이 종류에따라 보여줄 컴포넌트 변경
        return currentIPView(this.campaignType)
      }
    },
    mounted () {
      window.scroll(0, 0)
      document.body.scrollTop = 0
    }
  }
</script>



// WEBPACK FOOTER //
// ContractImp.vue?1e7b7987